import { initReactI18next } from 'react-i18next';
import type { InitOptions, Resource, TFunction } from 'i18next';
import i18next from 'i18next';
import { getAppToken } from 'utils';

export const DEFAULT_LOCALE = 'en';
const ALLOWED_LOCALES = new Set<string>().add(DEFAULT_LOCALE);

const userLocale = getAppToken()?.localeKey?.split('_')[0];
const lng = userLocale && ALLOWED_LOCALES.has(userLocale) ? userLocale : DEFAULT_LOCALE;

export const i18n = async (): Promise<TFunction> => {
    const resources = await import(`../../locales/${lng}/index.ts`).then(
        (module: { default: Resource }) => module.default,
    );

    const config: InitOptions = {
        defaultNS: 'common',
        debug: import.meta.env.DEV,
        load: 'languageOnly',
        fallbackLng: DEFAULT_LOCALE,
        lng,
        resources,
        interpolation: {
            escapeValue: false, // react already safes from xss
        },
        // react i18next special options (optional)
        react: {
            bindI18n: 'languageChanged loaded',
            nsMode: 'default',
            useSuspense: true,
        },
    };

    return i18next.use(initReactI18next).init(config);
};
